import { render, staticRenderFns } from "./errorDio.vue?vue&type=template&id=1cb0a700&scoped=true"
import script from "./errorDio.vue?vue&type=script&lang=js"
export * from "./errorDio.vue?vue&type=script&lang=js"
import style0 from "./errorDio.vue?vue&type=style&index=0&id=1cb0a700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb0a700",
  null
  
)

export default component.exports